import asyncCom from '@/CommonDP/commons/asyncCom';
import flowService from "@/CommonDP/service/flow-service";
import { initApprovalFlowKey, FLOW_TYPE } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import { v4 as uuidv4 } from 'uuid';

/**
 * @param {*} data
 * @param {*} data.approveType 流程类型--发起:add 审批:edit 查看:view 暂存：draft 重新发起：again
 * @param {*} data.flowDefinitionId 流程定义id
 * @param {*} data.flowInstanceId 流程实例id: approveType为edit,view,again 必填
 * @param {*} data.flowKey 流程key
 * @param {*} data.currentVersionId 当前版本
 * @param {*} data.businessId 暂存id :approveType为draft 必填
 * @param {*} data.enterpriseId 企业id
 * @param {*} data.isProject 是否是项目内审批
 * @param {*} data.fileInfoList 文件列表信息
 * @param {*} data.prjId 项目id
 * @param {*} data.dialogWidth 流程弹框宽度
 * @param {*} data.dialogHeight 流程弹框高度
 * @param {*} data.fullscreen 是否全屏
 * @returns
 */
export const openFlow = async (data) => {
  const uuid = await setFlowData(data);
  const props = { ...data, uuid };
  const { default: components } = await import("./flowWebSummary.vue");
  return await asyncCom(components, {}, props);
};
// H5的打开流程
export const openH5Flow = async (data) => {
  return await setFlowData(data);
};

// 设置流程数据
export async function setFlowData(data) {
  const flowType = FLOW_TYPE[data.approveType]; // 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
  const uuid = uuidv4();
  if (flowType === 1) {
    const { currentVersionId, flowDefinitionId, flowKey, prjId } = data;
    const flowData = await queryFlowDef(currentVersionId, flowDefinitionId, flowKey);
    const flowInfo = { ...data, ...flowData, flowType, prjId };
    initApprovalFlowKey(uuid, flowInfo);
  } else if (flowType === 4) {
    const { currentVersionId = "", businessId } = data;
    const { flowDefinitionId, prjId, json, flowKey } = await draftDetail(businessId);
    const flowData = await queryFlowDef(currentVersionId, flowDefinitionId, flowKey);
    const flowInfo = { ...data, ...flowData, flowType, flowDefinitionId, prjId, json };
    initApprovalFlowKey(uuid, flowInfo);
  }
  if (flowType === 5) {
    const { flowInstanceId } = data;
    const { flowInfo, fileInfoList, object } = await getAgainData(flowInstanceId);
    const flowData = await getFlowInstanceIdDef(flowInstanceId);
    initApprovalFlowKey(uuid, { ...data, ...flowInfo, ...flowData, flowType, json: object, fileInfoList });
  }
  if (flowType === 2 || flowType === 3) {
    const { flowInstanceId } = data;
    const { flowInfo, flowInfo: { ccList = [] }, object, fileInfoList = [], formFieldPermissionList } = await getAgainData(flowInstanceId);
    const flowData = await getFlowInstanceIdDef(flowInstanceId);
    initApprovalFlowKey(uuid, { ...data, ...flowInfo, ...flowData, ccList, flowType, json: object, formFieldPermissionList, fileInfoList });
  }
  return uuid;
}

async function queryFlowDef(currentVersionId = "", flowDefinitionId = "", flowKey = "") {
  const res = await flowService.queryFlowDef(currentVersionId, flowDefinitionId, flowKey);
  return res.data || {};
}
async function draftDetail(businessId) {
  const res = await flowService.getDraftFlowDetail(businessId);
  return res.data || {};
}
async function getAgainData(flowInstanceId) {
  const res = await flowService.getBusinessForm(flowInstanceId);
  return res.data || {};
}
// 根据流程实例id获取流程详情
async function getFlowInstanceIdDef(flowInstanceId) {
  const res = await flowService.getFlowInstanceIdDef(flowInstanceId);
  return res.data || {};
}

// 根据流程实例id更新流程H5页面
export const updateH5Flow = async (uuid, flowInstanceId) => {
  const flowData = await getFlowInstanceIdDef(flowInstanceId);
  const { flowInfo, object, fileInfoList, formFieldPermissionList } = await getAgainData(flowInstanceId);
  const { status } = flowInfo || {};
  const approveType = APPROVE_TYPE[status];
  const flowType = FLOW_TYPE[approveType]; // 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
  initApprovalFlowKey(uuid, { flowType, ...flowData, ...flowInfo, json: object, formFieldPermissionList, fileInfoList });
};
// 流程状态对应的approveType
export const APPROVE_TYPE = {
  1: "view", // 已通过
  2: "edit", // 审批中
  3: "view", // 已撤回
  9: "draft", // 草稿
  0: "view" // 已驳回
};
